import React, { FunctionComponent, memo } from "react";

import { IProps } from "./basic-chart-tooltip.types";
import "./basic-chart-tooltip.scss";

/**
 * Tooltip to display the basic details, a value with label
 * @param props.frequency    Number of interactions
 */
const BasicChartTooltip: FunctionComponent<IProps> = ({ frequency, label }) => {
    return (
        <div className="basic-chart-tooltip">
            <span className="basic-chart-tooltip__value">{frequency.toLocaleString()}</span>{" "}
            <span className="basic-chart-tooltip__label">{label}</span>
        </div>
    );
};

export default memo(BasicChartTooltip);
